import { SizableText, Stack, XStack } from '@my/ui'

interface ChangePostTypeButtonProps {
  onPress: () => void
  label: string
  icon: React.ReactNode
}

export const ChangePostTypeButton = ({ onPress, label, icon }: ChangePostTypeButtonProps) => {
  return (
    <XStack
      tag="button"
      gap="$2"
      ai="center"
      cursor="pointer"
      onPress={onPress}
      hoverStyle={{
        opacity: 0.6,
      }}
      focusStyle={{
        opacity: 0.5,
      }}
      pressStyle={{
        opacity: 0.5,
      }}
    >
      <Stack ai="center" jc="center" w={38} h={38} bg="$overlay4" br={1000} bw={1} boc="$overlay2">
        {icon}
      </Stack>
      <SizableText size="$2" fow="500" color="$overlay11">
        {label}
      </SizableText>
    </XStack>
  )
}
